import React, { useContext, useState } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import DatePicker from 'react-datepicker';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import { ThemeContext } from '../Common/ThemeProvider';
import { confirmAlert } from 'react-confirm-alert';
import FailureAlert from '../Common/Failure';
import Select from 'react-select';
import {
    ValidateLeads, ValidateQuotes, ValidateDlvr, CallBackAlert,
    PreLoadAddress
} from '../Common/Validations/validation';
import moment from 'moment';
import Autocomplete from "react-google-autocomplete";
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const InternalServ = {
    OriginAddress: "",
    OriginCity: "",
    OriginState: "",
    OriginCountry: "India",
    OriginPinCode: 0,
    OriginEmailID: "",
    OriginContact: 0,
    OriginOrg: "",
    DestAddress: "",
    DestCity: "",
    DestState: "",
    DestCountry: "India",
    DestPinCode: 0,
    DestEmailID: "",
    DestContact: 0,
    DestOrg: "",
    Remarks: "",
    TotalCFT: 0,
    SourceKeyword: "",
    DestKeyword: "",
    TotalPackages: 0,
    TrackingLink: "",
    DeliveryDate: null,
    HardmenRequired: 0,
    LocalSettling: 0,
    WareHouseRequired: 0,
    LiftAvailable: 0,
    FloorNumber: 0,
    TotalManPower: 0,
    DestCustomerName: "",
    TruckNumber: "",
    DriverContact: 0,
    CustName: "",
    CustContact: 0,
    CustEmail: "",
    CustSource: "",
    CustDest: ""
};

const DestinationAddressInfo = {
    Address: "",
    City: "",
    State: "",
    Country: "India",
    PinCode: 0
}

const ServiceType = [
    { value: 1, label: "Pickup" },
    { value: 2, label: "Delivery" },
    { value: 3, label: "Leads" },
    { value: 4, label: "Quotes" }
]

const InternalReq = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Internal, setInternal] = useState(InternalServ);
    const [AddressSearch, setAddressSearch] = useState(DestinationAddressInfo);
    const [OriginPartner, setOriginPartner] = useState([]);
    const [DestPartner, setDestPartner] = useState([]);
    const [DestPartnerDetailsRaw, setDestPartnerDetailsRaw] = useState([]);
    const [SelectedDestPartnerDetailsRaw, setSelectedDestPartnerDetailsRaw] = useState({});
    const [SelectedServiceType, setSelectedServiceType] = useState({ value: null, label: null });

    const OnSourcePatnerLoad = () => {
        if (Internal.SourceKeyword !== "") {
            Axiosfetch(baseURL + "GetActiveOrganizationByCity", "POST", { Keywords: Internal.SourceKeyword }, OnSourcePatnerLoadSuccess, Failure);
        }
        else {
            Alert.error("Please enter Origin Keyword", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnDestPatnerLoad = () => {

        if (Internal.DestKeyword !== "") {
            Axiosfetch(baseURL + "GetActiveOrganizationByCity", "POST", { Keywords: Internal.DestKeyword }, OnDestPatnerLoadSuccess, Failure);
        }
        else {
            Alert.error("Please enter Destination Keyword", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setInternal({ ...Internal, [e.target.name]: value });
    };

    const onTruckTextChange = (e) => {
        let data = e.target.value ? e.target.value.trim().toUpperCase() : "";
        data = data ? data.toUpperCase().split(" ").join("") : "";
        setInternal({ ...Internal, [e.target.name]: data });
    };

    const onAddressTextChange = (e) => {
        let value = e.target.value;
        setAddressSearch({ ...AddressSearch, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = parseFloat(e.target.value === "" ? 0 : e.target.value);
        setInternal({ ...Internal, [e.target.name]: value });
    };

    const onAddressNumberChange = (e) => {
        let value = parseFloat(e.target.value === "" ? 0 : e.target.value);
        setAddressSearch({ ...AddressSearch, [e.target.name]: value });
    };

    const OnSourcePatnerLoadSuccess = (data) => {
        if (data && data.length > 0) {
            let userlist = [];
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            data.forEach(org => {
                if ((userData && userData.Organization && userData.Organization[0]._id !== org._id) &&
                    ((org.ExpiryDate === undefined || org.ExpiryDate === null) ||
                        (org.ExpiryDate !== "" && moment() < moment(org.ExpiryDate)))) {
                    userlist.push({ value: org._id, label: org.Name + " [MFI " + org.City + "]" });
                }
            });

            setOriginPartner(userlist);
        }
        else {
            setOriginPartner([]);
        }
    };

    const OnDestPatnerLoadSuccess = (data) => {
        if (data && data.length > 0) {
            let userlist = [];
            setDestPartnerDetailsRaw(data);
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            data.forEach(org => {
                if ((userData && userData.Organization && userData.Organization[0]._id !== org._id) &&
                    ((org.ExpiryDate === undefined || org.ExpiryDate === null) ||
                        (org.ExpiryDate !== "" && moment() < moment(org.ExpiryDate)))) {
                    userlist.push({ value: org._id, label: org.Name + " [MFI " + org.City + "]" });
                }
            });
            setDestPartner(userlist);
        }
        else {
            setDestPartner([]);
        }
    };

    const onOriginPartnerChange = (OrgDetails) => {
        let org = OrgDetails ? OrgDetails.value : null;
        if (org !== null) {
            setInternal({ ...Internal, "OriginOrg": org });
        }
    };

    const onDestPartnerChange = (OrgDetails) => {
        let org = OrgDetails ? OrgDetails.value : null;
        if (org !== null) {
            var rawData = DestPartnerDetailsRaw.filter(u => u._id === org);
            if (rawData.length > 0) {
                setSelectedDestPartnerDetailsRaw(rawData[0])
            }
            else {
                setSelectedDestPartnerDetailsRaw([])
            }

            setInternal({ ...Internal, "DestOrg": org });
        }
    };

    const OnInternalServSave = () => {
        if (SelectedServiceType && SelectedServiceType.value !== null) {
            switch (SelectedServiceType.value) {
                case 2: SaveConfirmDlvr();
                    break;
                case 3: SaveLeads();
                    break;
                case 4: SaveQuotes();
                    break;
                default:
                    Alert.error("Selected Service Type not yet Supported. Coming soon", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
            };
        }
        else {
            Alert.error("Please enter valid Service Type", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onDeliveryDateChange = (date) => {
        setInternal({ ...Internal, "DeliveryDate": date });
    };

    const SaveLeads = () => {
        if (ValidateLeads(SelectedServiceType, Internal)) {
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            if (userData.Organization && userData.Organization.length > 0) {
                let InternalLeads = Internal;
                InternalLeads.OrgID = userData.Organization[0]._id;

                Axiosfetch(baseURL + "CreateInternalServLeads", "POST", InternalLeads, InternalServSaveSuccess, Failure);
            }
            else {
                Alert.error("Session Expired. Please Login again.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const SaveQuotes = () => {
        if (ValidateQuotes(SelectedServiceType, Internal)) {
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            if (userData.Organization && userData.Organization.length > 0) {
                let InternalQuotes = Internal;
                InternalQuotes.OrgID = userData.Organization[0]._id;

                Axiosfetch(baseURL + "CreateInternalServQuotes", "POST", InternalQuotes, InternalServSaveSuccess, Failure);
            }
            else {
                Alert.error("Session Expired. Please Login again.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const SaveConfirmDlvr = () => {
        if (ValidateDlvr(SelectedServiceType, Internal, AddressSearch)) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className={`custom-ui${CurrentTheme}`}>
                            <h5>Are you sure you want submit the Delivery Details ? </h5>
                            <p>Note : Please verify all the details before submitting.</p>
                            <button type="button" style={{ fontSize: "1.4rem", marginRight: "10px" }} title="Updated Selected Quotation" className="btn btn-Save" onClick={() => { SaveDlvr(); { onClose(); } }}>Yes</button>
                            <button type="button" className="btn btn-default" onClick={onClose}>No</button>
                        </div>
                    );
                }
            });
        }
    }

    const SaveDlvr = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData.Organization && userData.Organization.length > 0) {
            let InternalDlvr = Internal;
            InternalDlvr.DestAddress = AddressSearch.Address;
            InternalDlvr.DestCity = AddressSearch.City;
            InternalDlvr.DestState = AddressSearch.State;
            InternalDlvr.DestCountry = AddressSearch.Country;
            InternalDlvr.DestPinCode = AddressSearch.PinCode;
            InternalDlvr.OrgID = userData.Organization[0]._id;

            Axiosfetch(baseURL + "CreateInternalServDlvr", "POST", InternalDlvr, InternalDlvrServSaveSuccess, Failure);
        }
        else {
            Alert.error("Session Expired. Please Login again.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const InternalServSaveSuccess = (data) => {
        if (data.success) {
            setInternal(InternalServ);
            setSelectedServiceType({ value: null, label: null });
        }

        CallBackAlert(data);
    };

    const InternalDlvrServSaveSuccess = (data) => {
        if (data.success) {
            if (SelectedDestPartnerDetailsRaw && !IsUndefinedNullOrEmpty(SelectedDestPartnerDetailsRaw.UserDetails) &&
                SelectedDestPartnerDetailsRaw.UserDetails.length > 0) {
                var details = SelectedDestPartnerDetailsRaw.UserDetails[0];
                if (DestPartner.length > 0) {
                    var destNameData = DestPartner.filter(d => d.value === SelectedDestPartnerDetailsRaw._id);
                    if (destNameData.length > 0) {
                        var parsedUserData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
                        var emailData = {
                            destuser: `${destNameData[0].label.split('[')[1].split(']')[0]} [${details.FirstName} ${details.LastName}]`,
                            srcuser: parsedUserData.Organization.length > 0 ? `MFI ${parsedUserData.Organization[0].City} [${parsedUserData.FirstName} ${parsedUserData.LastName}]` : "",
                            tentdate: Internal.DeliveryDate !== null ? moment(Internal.DeliveryDate).local().format("DD/MM/YYYY") : "-",
                            tracklink: Internal.TrackingLink,
                            remarks: Internal.Remarks,
                            jobid: `${data.data.JobID}_${moment(data.data.createdAt).local().format("DDMMYYYY")}`,
                            cft: Internal.TotalCFT,
                            packages: Internal.TotalPackages,
                            custname: Internal.DestCustomerName,
                            destaddress: `${Internal.DestAddress}, ${Internal.DestCity}, ${Internal.DestState}, ${Internal.DestCountry} ${Internal.DestPinCode}`,
                            destcontact: Internal.DestContact,
                            toemail: details.EmailID
                        }

                        Axiosfetch(baseURL + "SendDeliveryEmailMessage", "POST", emailData, InternalEmailSuccess, Failure);
                    }
                }
            }

            setInternal(InternalServ);
            setSelectedServiceType({ value: null, label: null });
        }

        CallBackAlert(data);
    };

    const InternalEmailSuccess = (data) => {
        // do nothing
    }

    const onServiceTypeChange = (serviceType) => {
        if (serviceType === null) {
            setSelectedServiceType({ value: null, label: null });
        }
        else {
            setSelectedServiceType(serviceType);
        }
        if (serviceType !== null && serviceType.value === 3) {
            setInternal({ ...Internal, "TotalCFT": 0 });
        }
    };

    const onHardmenRequiredChange = (e) => {
        setInternal({ ...Internal, "HardmenRequired": e.target.checked ? 1 : 0 });
    };

    const onLocalSettlingChange = (e) => {
        setInternal({ ...Internal, "LocalSettling": e.target.checked ? 1 : 0 });
    };

    const onWareHouseChange = (e) => {
        setInternal({ ...Internal, "WareHouseRequired": e.target.checked ? 1 : 0 });
    };

    const onLiftChange = (e) => {
        setInternal({ ...Internal, "LiftAvailable": e.target.checked ? 1 : 0 });
    };

    const FillAddress = (places) => {
        var placesResult = PreLoadAddress(places);
        setAddressSearch({
            ...AddressSearch,
            "Address": placesResult.Address, "City": placesResult.City,
            "State": placesResult.State, DestCountry: placesResult.Country,
            "PinCode": placesResult.PostalCode
        });

    }

    const OnTripLoad = () => {
        if (Internal.TruckNumber && Internal.TruckNumber !== "") {
            Axiosfetch(baseURL + "GetTrackLogsByTruckNumber", "POST", { TruckNumber: Internal.TruckNumber }, TruckNumberSuccess, Failure);
        }
        else {
            Alert.error("Please enter truck Number")
        }
    }

    const TruckNumberSuccess = (data) => {
        if (data && data.length > 0) {
            setInternal({ ...Internal, "TrackingLink": `http://${window.location.hostname}/TrackingDetails/${data[0].TripID}` });
        }
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row" style={{ margin: "5px" }}>
                    <div className="offset-md-2 col-md-7 col-12 align-right">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Internal Service Request</h5>
                    </div>
                    <div className="col-md-3 col-12 align-center">
                        <button disabled type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`}>Complaint</button>
                        <button type="button" style={{ fontSize: "1.4rem" }} onClick={OnInternalServSave} className={`btn btn-Save ${CurrentTheme}Focus`}>Save</button>
                    </div>
                </div>
                <div className="row" style={{ height: "70vh", margin: "10px", paddingTop: "10px", overflow: "auto" }}>
                    <div className={((SelectedServiceType.value !== null && SelectedServiceType.value <= 2) ? "col-md-6 col-sm-6 col-12" : "col-md-12 col-sm-12 col-12")}>
                        <div className="InteralReqSection">
                            <div className="InternalreqHeader">Service Type<span className="mandatoryStar">*</span></div>
                            <div style={{ padding: "20px" }}>
                                <Select styles={{ borderRadius: "20px" }} isClearable={true}
                                    isSearchable={true} placeholder="Select Service Type"
                                    options={ServiceType} onChange={onServiceTypeChange}></Select>
                            </div>
                        </div>
                    </div>
                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 1 || SelectedServiceType.value === 2) && (<div className="col-md-6  col-sm-6">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">Total CFT<span className="mandatoryStar">*</span></div>
                                <table className="table" style={{ margin: "25px 0" }}>
                                    <tbody>
                                        <tr>
                                            <td><input placeholder='CFT *' disabled={(SelectedServiceType !== null && SelectedServiceType.value === 3 ? true : false)} value={(isNaN(Internal.TotalCFT) || Internal.TotalCFT <= 0 ? "" : Internal.TotalCFT)} name="TotalCFT" onChange={onNumberChange} className="form-control" type="text"></input></td>
                                            {SelectedServiceType.value === 2 && (<td><input placeholder='No. of Packages *' type="text" value={(isNaN(Internal.TotalPackages) || Internal.TotalPackages <= 0 ? "" : Internal.TotalPackages)} name="TotalPackages"
                                                onChange={onNumberChange} className="form-control"></input></td>)}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>)}

                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 1 || SelectedServiceType.value === 2) && (<div className="col-md-6 col-12">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">Origin Address<span className="mandatoryStar">*</span></div>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>City<span className="mandatoryStar">*</span></td>
                                            <td><input value={Internal.OriginCity} name="OriginCity" onChange={onTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>PinCode<span className="mandatoryStar">*</span></td>
                                            <td><input value={(isNaN(Internal.OriginPinCode) || Internal.OriginPinCode <= 0 ? "" : Internal.OriginPinCode)} name="OriginPinCode" onChange={onNumberChange} className="form-control" type="text"></input></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {SelectedServiceType.value === 2 && (<div className="InteralReqSection mt-4">
                                <div className="InternalreqHeader">Additional Info</div>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>HMS Required</td>
                                            <td>
                                                <input style={{ scale: "1.5" }} type="checkbox" checked={Internal.HardmenRequired === 1} onChange={onHardmenRequiredChange} name="HardmenRequired"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Local Settling</td>
                                            <td>
                                                <input style={{ scale: "1.5" }} type="checkbox" checked={Internal.LocalSettling === 1} onChange={onLocalSettlingChange} name="LocalSettling"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>WareHouse Required</td>
                                            <td>
                                                <input style={{ scale: "1.5" }} type="checkbox" checked={Internal.WareHouseRequired === 1} onChange={onWareHouseChange} name="WareHouseRequired"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Lift Available</td>
                                            <td>
                                                <input style={{ scale: "1.5" }} type="checkbox" checked={Internal.LiftAvailable === 1} onChange={onLiftChange} name="WareHouseRequired"></input>
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #ccc" }}>
                                            <td colSpan={2}>
                                                <div style={{ color: "red" }}><strong>Note : </strong><span>Please provide Instructions for the above checked fields in Instructions/Remarks section.</span></div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Floor Number</td>
                                            <td>
                                                <input type="number" name="FloorNumber" value={Internal.FloorNumber <= 0 ? 0 : Internal.FloorNumber.toString()}
                                                    onChange={onNumberChange} className="form-control"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Man Power</td>
                                            <td>
                                                <input type="number" name="TotalManPower" value={Internal.TotalManPower <= 0 ? 0 : Internal.TotalManPower.toString()}
                                                    onChange={onNumberChange} className="form-control"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Tent. Delivery Date</td>
                                            <td>
                                                <DatePicker className="TextInputStyle datepicker"
                                                    selected={Internal.DeliveryDate}
                                                    onChange={onDeliveryDateChange}
                                                    name="DeliveryDate"
                                                    showTimeSelect
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>)}
                        </div>)}
                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 1 || SelectedServiceType.value === 2) && (<div className="col-md-6 col-12">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">Destination Info<span className="mandatoryStar">*</span></div>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>Search Address</td>
                                            <td>
                                                <Autocomplete className="form-control"
                                                    apiKey={process.env.REACT_APP_MAPS_KEY}
                                                    onPlaceSelected={(place) => {
                                                        FillAddress(place);
                                                    }}
                                                    options={{
                                                        types: ["geocode"],
                                                    }}></Autocomplete>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Address<span className="mandatoryStar">*</span></td>
                                            <td>
                                                <textarea value={AddressSearch.Address} name="Address" onChange={onAddressTextChange} style={{ resize: "none" }} rows="1" className="form-control"></textarea>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>City<span className="mandatoryStar">*</span></td>
                                            <td><input value={AddressSearch.City} name="City" onChange={onAddressTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>State<span className="mandatoryStar">*</span></td>
                                            <td><input value={AddressSearch.State} name="State" onChange={onAddressTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>Country<span className="mandatoryStar">*</span></td>
                                            <td><input value={AddressSearch.Country} name="Country" onChange={onAddressTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>PinCode<span className="mandatoryStar">*</span></td>
                                            <td><input value={(isNaN(AddressSearch.PinCode) || AddressSearch.PinCode <= 0 ? "" : AddressSearch.PinCode)}
                                                name="PinCode" onChange={onAddressNumberChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>Email ID</td>
                                            <td><input value={Internal.DestEmailID} name="DestEmailID" onChange={onTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>Customer Name<span className="mandatoryStar">*</span></td>
                                            <td>
                                                <input value={Internal.DestCustomerName} name="DestCustomerName" onChange={onTextChange} className="form-control" type="text"></input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Contact Number<span className="mandatoryStar">*</span></td>
                                            <td>
                                                <input value={(isNaN(Internal.DestContact) || Internal.DestContact <= 0 ? "" : Internal.DestContact)} name="DestContact" onChange={onTextChange} className="form-control" type="text"></input>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>)}

                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 3 || SelectedServiceType.value === 4) && (<div className="col-md-6 col-12">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">Partner<span className="mandatoryStar">*</span></div>
                                <div style={{ padding: "20px", display: "flex" }}>
                                    <input type="text" placeholder="Enter City" name="SourceKeyword" onChange={onTextChange} className="form-control"></input>
                                    <button onClick={OnSourcePatnerLoad} style={{ marginLeft: "10px" }} className="btn btn-default">Load</button>
                                </div>
                                <div style={{ padding: "20px" }}>
                                    <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Source Partner"
                                        options={OriginPartner} onChange={onOriginPartnerChange}></Select>
                                </div>
                            </div>
                        </div>)}



                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value > 2) && (<div className="col-md-6 col-12">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">{(SelectedServiceType.value === 3 ? "Customer Info" : "Source / Destination")}<span className="mandatoryStar">*</span></div>
                                <table className="table">
                                    <tbody>
                                        {SelectedServiceType.value === 3 && (<tr>
                                            <td>Name<span className="mandatoryStar">*</span></td>
                                            <td><textarea value={Internal.CustName} name="CustName" onChange={onTextChange} style={{ resize: "none" }} rows="1" className="form-control"></textarea></td>
                                        </tr>)}
                                        {SelectedServiceType.value === 3 && (<tr>
                                            <td>Email ID</td>
                                            <td><input value={Internal.CustEmail} name="CustEmail" onChange={onTextChange} className="form-control" type="text"></input></td>
                                        </tr>)}
                                        {SelectedServiceType.value === 3 && (<tr>
                                            <td>Contact Number<span className="mandatoryStar">*</span></td>
                                            <td>
                                                <input value={Internal.CustContact} name="CustContact" onChange={onTextChange} className="form-control" type="text"></input>
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <td>Source City<span className="mandatoryStar">*</span></td>
                                            <td><input value={Internal.CustSource} name="CustSource" onChange={onTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        <tr>
                                            <td>Dest City<span className="mandatoryStar">*</span></td>
                                            <td><input value={Internal.CustDest} name="CustDest" onChange={onTextChange} className="form-control" type="text"></input></td>
                                        </tr>
                                        {SelectedServiceType.value === 4 && (<tr>
                                            <td>CFT<span className="mandatoryStar">*</span></td>
                                            <td><input disabled={(SelectedServiceType !== null && SelectedServiceType.value === 3 ? true : false)} value={(isNaN(Internal.TotalCFT) || Internal.TotalCFT <= 0 ? "" : Internal.TotalCFT)} name="TotalCFT" onChange={onNumberChange} className="form-control" type="text"></input></td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>)}



                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 1 || SelectedServiceType.value === 2) && (<div className="col-md-6 col-sm-6 col-12">
                            {SelectedServiceType.value !== 2 ? (<div className="InteralReqSection">
                                <div className="InternalreqHeader">Origin Partner<span className="mandatoryStar">*</span></div>
                                <div style={{ padding: "20px", display: "flex" }}>
                                    <input type="text" placeholder="Origin Service City" name="SourceKeyword" onChange={onTextChange} className="form-control"></input>
                                    <button onClick={OnSourcePatnerLoad} style={{ marginLeft: "10px" }} className="btn btn-default">Load</button>
                                </div>
                                <div style={{ padding: "20px" }}>
                                    <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Source Partner"
                                        options={OriginPartner} onChange={onOriginPartnerChange}></Select>
                                </div>
                            </div>) : (
                                <div className="InteralReqSection">
                                    <div className="InternalreqHeader">Transit Details<span className="mandatoryStar">*</span></div>
                                    <table className='table'>
                                        <tbody>
                                            <tr>
                                                <td>Truck Number<span className="mandatoryStar">*</span></td>
                                                <td>
                                                    <div style={{ padding: "20px", display: "flex" }}>
                                                        <input type="text" name="TruckNumber" value={Internal.TruckNumber}
                                                            onChange={onTruckTextChange} className="form-control"></input>
                                                        <button onClick={OnTripLoad} style={{ marginLeft: "10px" }} className="btn btn-default">Load</button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Tracking Link<span className="mandatoryStar">*</span></td>
                                                <td>
                                                    <input type="text" name="TrackingLink" value={Internal.TrackingLink}
                                                        onChange={onTextChange} className="form-control"></input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Driver Contact<span className="mandatoryStar">*</span></td>
                                                <td>
                                                    <input type="text" name="DriverContact"
                                                        value={(isNaN(Internal.DriverContact) || Internal.DriverContact <= 0 ? "" : Internal.DriverContact)}
                                                        onChange={onTextChange} className="form-control"></input>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>)}
                    {SelectedServiceType && SelectedServiceType.value !== null &&
                        (SelectedServiceType.value === 1 || SelectedServiceType.value === 2) && (<div className="col-md-6  col-sm-6 col-12">
                            <div className="InteralReqSection">
                                <div className="InternalreqHeader">Destination Partner<span className="mandatoryStar">*</span></div>
                                <div style={{ padding: "20px", display: "flex" }}>
                                    <input type="text" value={Internal.DestKeyword} name="DestKeyword" onChange={onTextChange} placeholder="Dest. Service City" className="form-control"></input>
                                    <button onClick={OnDestPatnerLoad} style={{ marginLeft: "10px" }} className="btn btn-default">Load</button>
                                </div>
                                <div className="InternalreqHeader">Destination Partner<span className="mandatoryStar">*</span></div>
                                <div style={{ padding: "22px" }}>
                                    <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Destination Partner"
                                        options={DestPartner} onChange={onDestPartnerChange}></Select>
                                </div>
                            </div>
                        </div>)}
                    {SelectedServiceType && SelectedServiceType.value !== null && (<div className="col-md-12 col-sm-12 col-12"><div>
                        <div className="InteralReqSection">
                            <div className="InternalreqHeader">{SelectedServiceType.value === 2 ? "Instructions /" : ""} Remarks<span className="mandatoryStar">*</span></div>
                            <div style={{ padding: "20px" }}>
                                <textarea value={Internal.Remarks} name="Remarks" onChange={onTextChange} style={{ resize: "none" }} className="form-control"></textarea></div>
                        </div>
                    </div>
                        {SelectedServiceType && SelectedServiceType.value === 2 && (<div>
                            <h5>Terms and Conditions</h5>
                            <ul>
                                <li>This form should be filled with correct details. </li>
                                <li>If a particular city have more than one member, then discuss with the delivery partner and choose the most convenient one for yourself.</li>
                                <li>The shipment must be under tracking surveillance for smooth delivery.</li>
                            </ul>
                        </div>)}
                    </div>)}
                </div>
            </div>
        </div>
    );
};

export default InternalReq;